export const modalNewTermsAlternativeTitle: boolean = true;
